import { useErrors } from "providers/ErrorsProvider"
import { useEffect } from "react"
import { errors } from "store/errors";
import styled from "styled-components"

import { MaterialIcon } from "./MaterialIcon";

export const ErrorsHandler = () => {

    const { currentErrors, unsetError } = useErrors();

    useEffect(() => {
        const timers = [];

        currentErrors.forEach(err => {
            const e = errors[err];
            if(e?.autoUnset)
            {
                const timer = setTimeout(() => {
                    unsetError(err, true);
                }, 2500);

                timers.push(timer);
            }
        });

        return () => {
            timers.forEach(timer => clearTimeout(timer));
        };

    }, [currentErrors, unsetError]);

    return (
        <StyledErrorsHandler>
            {
                [...currentErrors].map(err => {
                    const e = errors[err];
                    
                    if(e)
                    {
                        return (
                            <Error
                                key={err}
                                $state={e.state}
                            >
                                <div className="iconContainer">
                                    {
                                        e.state === 'success' ? <MaterialIcon name='info' weight={400}/> :
                                        e.state === 'warning' ? <MaterialIcon name='warning' weight={400}/> :
                                        e.state === 'error' ? <MaterialIcon name='error' weight={400}/> :
                                        <MaterialIcon name='info' weight={400}/>
                                    }
                                </div>
                                <div className="errorContent">
                                    <div className="errorHeader">
                                        {e.title}
                                        <MaterialIcon
                                            name='close'
                                            weight={300}
                                            size='sm'
                                            onClick={() => unsetError(err)}
                                        />
                                    </div>
                                    {
                                        e.description ?
                                        <div className="errorDescription">
                                            {e.description}
                                        </div>
                                        : null
                                    }
                                    
                                </div>
                                
                            </Error>
                        )
                    }
                    else return null
                    
                })
            }
        </StyledErrorsHandler>
    )
}

const StyledErrorsHandler = styled.div`
    position: absolute;
    right: ${({theme}) => theme.spacing.xxl};
    bottom: ${({theme}) => theme.spacing.xxl};
    z-index: 5000;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};
`

const Error = styled.div`
    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    border-left: none;
    background: ${({theme}) => theme.colors.neutralPrimaryBackground};
    filter: ${({theme}) => 'drop-shadow(0 2px 2px rgba(' + theme.colors.neutralSecondaryForegroundRGB+ ', 0.15))'};
    border-radius: ${({theme}) => theme.cornerRadius.lg};
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacing.lg};
    padding: ${({theme}) => theme.spacing.md};
    padding-left: ${({theme}) => theme.spacing.lg};
    position: relative;
    overflow: hidden;

    &::before
    {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 4px;
        background: ${({$state, theme}) =>
                $state === 'success' ? theme.colors.successForeground :
                $state === 'warning' ? theme.colors.warningForeground :
                $state === 'error' ? theme.colors.errorForeground :
                theme.colors.accentForeground
            };
    }   

    &:has(div.errorDescription)
    {
        align-items: flex-start;
    }

    div.iconContainer
    {
        padding: ${({theme}) => theme.spacing.sm};
        border-radius: ${({theme}) => theme.cornerRadius.md};
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${({$state, theme}) =>
                $state === 'success' ? theme.colors.successBackground :
                $state === 'warning' ? theme.colors.warningBackground :
                $state === 'error' ? theme.colors.errorBackground :
                theme.colors.accentBackground
            };

        color: ${({$state, theme}) =>
            $state === 'success' ? theme.colors.successForeground :
            $state === 'warning' ? theme.colors.warningForeground :
            $state === 'error' ? theme.colors.errorForeground :
            theme.colors.accentForeground
        }
    }

    div.errorContent
    {
        width: 250px;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        
        div.errorHeader
        {
            display: flex;
            justify-content: space-between;
            font-weight: 600;

            .icon
            {
                cursor: pointer;
                color: ${({theme}) => theme.colors.mutedForeground};
            }
        }

        div.errorDescription
        {
            color: ${({theme}) => theme.colors.mutedForeground};
            padding-right: 18px;
        }
    }
`   